/**
 * Client-side read time for an article's HTML (Asana 1219952231021031).
 * Strip tags, count whitespace-separated words, divide by the reading speed,
 * round up, never below one minute. There is no backend field for this.
 */
export const ARTICLE_WORDS_PER_MINUTE = 238;

export const countArticleWords = (html: string): number =>
  html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;

export const estimateReadTimeMinutes = (html: string): number =>
  Math.max(1, Math.ceil(countArticleWords(html) / ARTICLE_WORDS_PER_MINUTE));
